import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CURRENCIES, CURRENCIES_SYMBOLS, LINK, MORE_INFO_NAMES } from 'constants/index';
export var isNumber = function isNumber(n) {
  return Number(n) === n;
};

var formatCurrency = function formatCurrency(currency) {
  if (CURRENCIES[currency.toLowerCase()]) {
    return CURRENCIES_SYMBOLS[currency.toLowerCase()];
  }

  return currency;
};

export var getFormattedPayments = function getFormattedPayments(formatMessage, percent, absolute, min) {
  var max = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var currency = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'UAH';
  var formattedCurrency = Array.isArray(currency) ? currency.length && currency.join('/') || 'UAH' : formatCurrency(currency);
  var formattedPercent = isNumber(percent) && !!percent ? "".concat(percent, "%") : '';
  var formattedAbsolute = isNumber(absolute) && absolute ? "".concat(absolute, " ").concat(formattedCurrency) : '';
  var formattedMin = isNumber(min) && min ? "(".concat(formatMessage({
    id: 'min'
  }), " ").concat(min, " ").concat(formattedCurrency, ")") : '';
  var formattedMax = isNumber(max) && max ? "(".concat(formatMessage({
    id: 'max'
  }), " ").concat(max, " ").concat(formattedCurrency, ")") : '';
  var formattedPayments = [formattedPercent, formattedAbsolute, formattedMin, formattedMax].filter(function (el) {
    return !!el;
  }).join(' ') || formatMessage({
    id: 'MenuItems.params.free'
  });
  return formattedPayments;
};
export var getMenu = function getMenu(formatMessage) {
  var menu = [{
    name: formatMessage({
      id: 'MenuItems.general'
    }),
    isActive: true,
    getParams: function getParams(_ref) {
      var productClientType = _ref.productClientType,
          productClientActivityType = _ref.productClientActivityType,
          firstAccountOpeningFee = _ref.firstAccountOpeningFee,
          addAccountOpeningFee = _ref.addAccountOpeningFee,
          productAccountOpeningRemote = _ref.productAccountOpeningRemote,
          productAccountOpeningDescription = _ref.productAccountOpeningDescription,
          monthlyFeeDescription = _ref.monthlyFeeDescription,
          monthlyFee = _ref.monthlyFee,
          annualFee = _ref.annualFee,
          accountClosingFee = _ref.accountClosingFee,
          currency = _ref.currency,
          additionalCurrencies = _ref.additionalCurrencies;
      var prodAccOpeningDescr = productAccountOpeningDescription || formatMessage({
        id: 'MenuItems.params.possible'
      });
      var prodAccOpeningRemote = productAccountOpeningRemote ? prodAccOpeningDescr : formatMessage({
        id: 'MenuItems.params.impossible'
      });
      var feeDescr = monthlyFee || annualFee ? [monthlyFee && "".concat(monthlyFee, " ").concat(formatMessage({
        id: 'MenuItems.params.monthlyFee'
      }, {
        currency: 'UAH'
      })), annualFee && "".concat(annualFee, " ").concat(formatMessage({
        id: 'MenuItems.params.annualFee'
      }, {
        currency: 'UAH'
      }))].filter(function (el) {
        return !!el;
      }).join(formatMessage({
        id: 'MenuItems.params.or'
      })) : formatMessage({
        id: 'MenuItems.params.free'
      });
      return {
        productClientType: productClientType.map(function (el) {
          return formatMessage({
            id: "BankCardItem.productClientType.".concat(el.toLowerCase())
          });
        }).join(', '),
        productClientActivityType: productClientActivityType.map(function (el) {
          return formatMessage({
            id: "MoreFilters.multiSelect.activityType.".concat(el)
          });
        }),
        accountOpening: "".concat(firstAccountOpeningFee, " ").concat(formatMessage({
          id: 'MenuItems.params.UAH'
        })),
        addAccount: "".concat(addAccountOpeningFee, " ").concat(formatMessage({
          id: 'MenuItems.params.UAH'
        })),
        accountOpeningRemote: prodAccOpeningRemote,
        fee: monthlyFeeDescription || feeDescr,
        accountClosing: accountClosingFee ? "".concat(accountClosingFee, " ").concat(formatMessage({
          id: 'MenuItems.params.UAH'
        })) : formatMessage({
          id: 'MenuItems.params.free'
        }),
        availableCurrencies: [currency].concat(_toConsumableArray(additionalCurrencies)).join(', ')
      };
    }
  }, {
    name: formatMessage({
      id: 'MenuItems.payments'
    }),
    isActive: false,
    getParams: function getParams(_ref2) {
      var paymentInternalDescription = _ref2.paymentInternalDescription,
          paymentInternalPercent = _ref2.paymentInternalPercent,
          paymentInternalAbsolute = _ref2.paymentInternalAbsolute,
          paymentInternalMin = _ref2.paymentInternalMin,
          paymentSelfDescription = _ref2.paymentSelfDescription,
          paymentSelfPercent = _ref2.paymentSelfPercent,
          selfPaymentSelfAbsolute = _ref2.selfPaymentSelfAbsolute,
          paymentSelfMin = _ref2.paymentSelfMin,
          paymentDescription = _ref2.paymentDescription,
          paymentPercent = _ref2.paymentPercent,
          paymentAbsolute = _ref2.paymentAbsolute,
          paymentMin = _ref2.paymentMin,
          paymentAdditionalFee = _ref2.paymentAdditionalFee;
      return _objectSpread({
        paymentInternal: paymentInternalDescription || getFormattedPayments(formatMessage, paymentInternalPercent, paymentInternalAbsolute, paymentInternalMin),
        paymentSelf: paymentSelfDescription || getFormattedPayments(formatMessage, paymentSelfPercent, selfPaymentSelfAbsolute, paymentSelfMin),
        payment: paymentDescription || getFormattedPayments(formatMessage, paymentPercent, paymentAbsolute, paymentMin)
      }, paymentAdditionalFee ? {
        additionalFee: paymentAdditionalFee
      } : {});
    }
  }, {
    name: formatMessage({
      id: 'MenuItems.receivingPayments'
    }),
    isActive: false,
    getParams: function getParams(_ref3) {
      var enrollmentCashDescription = _ref3.enrollmentCashDescription,
          enrollmentCashPercent = _ref3.enrollmentCashPercent,
          enrollmentCashAbsolute = _ref3.enrollmentCashAbsolute,
          enrollmentCashMin = _ref3.enrollmentCashMin,
          enrollmentCashMax = _ref3.enrollmentCashMax,
          enrollmentCardDescription = _ref3.enrollmentCardDescription,
          enrollmentCardPercent = _ref3.enrollmentCardPercent,
          enrollmentCardAbsolute = _ref3.enrollmentCardAbsolute,
          enrollmentCardMin = _ref3.enrollmentCardMin,
          enrollmentCardMax = _ref3.enrollmentCardMax,
          enrollmentCashlessDescription = _ref3.enrollmentCashlessDescription,
          enrollmentCashlessPercent = _ref3.enrollmentCashlessPercent,
          enrollmentCashlessAbsolute = _ref3.enrollmentCashlessAbsolute,
          enrollmentCashlessMin = _ref3.enrollmentCashlessMin,
          enrollmentCashlessMax = _ref3.enrollmentCashlessMax,
          internetAcquiringAvailable = _ref3.internetAcquiringAvailable,
          enrollmentInternetAcquiringDescription = _ref3.enrollmentInternetAcquiringDescription,
          enrollmentInternetAcquiringPercent = _ref3.enrollmentInternetAcquiringPercent,
          enrollmentInternetAcquiringAbsolute = _ref3.enrollmentInternetAcquiringAbsolute,
          enrollmentInternetAcquiringMin = _ref3.enrollmentInternetAcquiringMin,
          enrollmentInternetAcquiringMax = _ref3.enrollmentInternetAcquiringMax,
          tradeAcquiringAvailable = _ref3.tradeAcquiringAvailable,
          enrollmentTradeAcquiringDescription = _ref3.enrollmentTradeAcquiringDescription,
          enrollmentTradeAcquiringPercent = _ref3.enrollmentTradeAcquiringPercent,
          enrollmentTradeAcquiringAbsolute = _ref3.enrollmentTradeAcquiringAbsolute,
          enrollmentTradeAcquiringMin = _ref3.enrollmentTradeAcquiringMin,
          enrollmentTradeAcquiringMax = _ref3.enrollmentTradeAcquiringMax;
      return {
        enrollmentCash: enrollmentCashDescription || getFormattedPayments(formatMessage, enrollmentCashPercent, enrollmentCashAbsolute, enrollmentCashMin, enrollmentCashMax),
        enrollmentCard: enrollmentCardDescription || getFormattedPayments(formatMessage, enrollmentCardPercent, enrollmentCardAbsolute, enrollmentCardMin, enrollmentCardMax),
        enrollmentCashless: enrollmentCashlessDescription || getFormattedPayments(formatMessage, enrollmentCashlessPercent, enrollmentCashlessAbsolute, enrollmentCashlessMin, enrollmentCashlessMax),
        internetAcquiring: internetAcquiringAvailable ? enrollmentInternetAcquiringDescription || getFormattedPayments(formatMessage, enrollmentInternetAcquiringPercent, enrollmentInternetAcquiringAbsolute, enrollmentInternetAcquiringMin, enrollmentInternetAcquiringMax) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        }),
        tradeAcquiring: tradeAcquiringAvailable ? enrollmentTradeAcquiringDescription || getFormattedPayments(formatMessage, enrollmentTradeAcquiringPercent, enrollmentTradeAcquiringAbsolute, enrollmentTradeAcquiringMin, enrollmentTradeAcquiringMax) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        })
      };
    }
  }, {
    name: formatMessage({
      id: 'MenuItems.cashDeposit'
    }),
    isActive: false,
    getParams: function getParams(_ref4) {
      var proceedsEnrollmentCashboxAvailable = _ref4.proceedsEnrollmentCashboxAvailable,
          proceedsEnrollmentCashboxDescription = _ref4.proceedsEnrollmentCashboxDescription,
          proceedsEnrollmentCashboxPercent = _ref4.proceedsEnrollmentCashboxPercent,
          proceedsEnrollmentCashboxAbsolute = _ref4.proceedsEnrollmentCashboxAbsolute,
          proceedsEnrollmentCashboxMin = _ref4.proceedsEnrollmentCashboxMin,
          proceedsEnrollmentTerminalAvailable = _ref4.proceedsEnrollmentTerminalAvailable,
          proceedsEnrollmentTerminalDescription = _ref4.proceedsEnrollmentTerminalDescription,
          proceedsEnrollmentTerminalPercent = _ref4.proceedsEnrollmentTerminalPercent,
          proceedsEnrollmentTerminalAbsolute = _ref4.proceedsEnrollmentTerminalAbsolute,
          proceedsEnrollmentTerminalMin = _ref4.proceedsEnrollmentTerminalMin;
      return {
        proceedsEnrollmentCashbox: proceedsEnrollmentCashboxAvailable ? proceedsEnrollmentCashboxDescription || getFormattedPayments(formatMessage, proceedsEnrollmentCashboxPercent, proceedsEnrollmentCashboxAbsolute, proceedsEnrollmentCashboxMin) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        }),
        proceedsEnrollmentTerminal: proceedsEnrollmentTerminalAvailable ? proceedsEnrollmentTerminalDescription || getFormattedPayments(formatMessage, proceedsEnrollmentTerminalPercent, proceedsEnrollmentTerminalAbsolute, proceedsEnrollmentTerminalMin) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        })
      };
    }
  }, {
    name: formatMessage({
      id: 'MenuItems.cashWithdrawal'
    }),
    isActive: false,
    getParams: function getParams(_ref5) {
      var withdrawalCashboxDescription = _ref5.withdrawalCashboxDescription,
          withdrawalCashboxPercent = _ref5.withdrawalCashboxPercent,
          withdrawalCashboxAbsolute = _ref5.withdrawalCashboxAbsolute,
          withdrawalCashboxMin = _ref5.withdrawalCashboxMin,
          withdrawalForeignCashboxAvailable = _ref5.withdrawalForeignCashboxAvailable,
          withdrawalForeignCashboxDescription = _ref5.withdrawalForeignCashboxDescription,
          withdrawalForeignCashboxPercent = _ref5.withdrawalForeignCashboxPercent,
          withdrawalForeignCashboxAbsolute = _ref5.withdrawalForeignCashboxAbsolute,
          withdrawalForeignCashboxMin = _ref5.withdrawalForeignCashboxMin,
          withdrawalAtmAvailable = _ref5.withdrawalAtmAvailable,
          withdrawalAtmDescription = _ref5.withdrawalAtmDescription,
          withdrawalAtmPercent = _ref5.withdrawalAtmPercent,
          withdrawalAtmAbsolute = _ref5.withdrawalAtmAbsolute,
          withdrawalAtmMin = _ref5.withdrawalAtmMin,
          withdrawalForeignAtmAvailable = _ref5.withdrawalForeignAtmAvailable,
          withdrawalForeignAtmDescription = _ref5.withdrawalForeignAtmDescription,
          withdrawalForeignAtmPercent = _ref5.withdrawalForeignAtmPercent,
          withdrawalForeignAtmAbsolute = _ref5.withdrawalForeignAtmAbsolute,
          withdrawalForeignAtmMin = _ref5.withdrawalForeignAtmMin;
      return {
        withdrawalCashbox: withdrawalCashboxDescription || getFormattedPayments(formatMessage, withdrawalCashboxPercent, withdrawalCashboxAbsolute, withdrawalCashboxMin),
        withdrawalForeignCashbox: withdrawalForeignCashboxAvailable ? withdrawalForeignCashboxDescription || getFormattedPayments(formatMessage, withdrawalForeignCashboxPercent, withdrawalForeignCashboxAbsolute, withdrawalForeignCashboxMin) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        }),
        withdrawalAtm: withdrawalAtmAvailable ? withdrawalAtmDescription || getFormattedPayments(formatMessage, withdrawalAtmPercent, withdrawalAtmAbsolute, withdrawalAtmMin) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        }),
        withdrawalForeignAtm: withdrawalForeignAtmAvailable ? withdrawalForeignAtmDescription || getFormattedPayments(formatMessage, withdrawalForeignAtmPercent, withdrawalForeignAtmAbsolute, withdrawalForeignAtmMin) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        })
      };
    }
  }, {
    name: formatMessage({
      id: 'MenuItems.currencyOperations'
    }),
    isActive: false,
    getParams: function getParams(_ref6) {
      var foreignCurrencyBuyDescription = _ref6.foreignCurrencyBuyDescription,
          foreignCurrencyBuyPercent = _ref6.foreignCurrencyBuyPercent,
          foreignCurrencyBuyMin = _ref6.foreignCurrencyBuyMin,
          foreignCurrencySellDescription = _ref6.foreignCurrencySellDescription,
          foreignCurrencySellPercent = _ref6.foreignCurrencySellPercent,
          foreignCurrencySellMin = _ref6.foreignCurrencySellMin,
          foreignCurrencyExchangeAvailable = _ref6.foreignCurrencyExchangeAvailable,
          foreignCurrencyDescription = _ref6.foreignCurrencyDescription,
          foreignCurrencyExchangePercent = _ref6.foreignCurrencyExchangePercent,
          foreignCurrencyExchangeMin = _ref6.foreignCurrencyExchangeMin,
          swiftAvailable = _ref6.swiftAvailable,
          swiftDescription = _ref6.swiftDescription,
          swiftCurrency = _ref6.swiftCurrency,
          swiftPercent = _ref6.swiftPercent,
          swiftAbsolute = _ref6.swiftAbsolute,
          swiftMin = _ref6.swiftMin;
      return {
        foreignCurrencyBuy: foreignCurrencyBuyDescription || getFormattedPayments(formatMessage, foreignCurrencyBuyPercent, null, foreignCurrencyBuyMin),
        foreignCurrencySell: foreignCurrencySellDescription || getFormattedPayments(formatMessage, foreignCurrencySellPercent, null, foreignCurrencySellMin),
        foreignCurrencyExchange: foreignCurrencyExchangeAvailable ? foreignCurrencyDescription || getFormattedPayments(formatMessage, foreignCurrencyExchangePercent, null, foreignCurrencyExchangeMin) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        }),
        swift: swiftAvailable ? swiftDescription || getFormattedPayments(formatMessage, swiftPercent, swiftAbsolute, swiftMin, null, swiftCurrency) : formatMessage({
          id: 'MenuItems.params.serviceUnavailable'
        })
      };
    }
  }, {
    name: formatMessage({
      id: 'MenuItems.additionalBenefits'
    }),
    isActive: false,
    getParams: function getParams(_ref7) {
      var productCardDebitLinkName = _ref7.productCardDebitLinkName,
          productCardDebitLinkUrl = _ref7.productCardDebitLinkUrl,
          productCardCreditLinkName = _ref7.productCardCreditLinkName,
          productCardCreditLinkUrl = _ref7.productCardCreditLinkUrl,
          productClientBankName = _ref7.productClientBankName,
          clientBankWebLink = _ref7.clientBankWebLink,
          clientBankAppIosLink = _ref7.clientBankAppIosLink,
          clientBankAppAndroidLink = _ref7.clientBankAppAndroidLink,
          productConciergeServiceDescription = _ref7.productConciergeServiceDescription,
          productConciergeService = _ref7.productConciergeService,
          productAccountStatementDescription = _ref7.productAccountStatementDescription,
          productBusinessCreditsDescription = _ref7.productBusinessCreditsDescription,
          productBusinessDepositsDescription = _ref7.productBusinessDepositsDescription,
          productCashCollectionDescription = _ref7.productCashCollectionDescription,
          productBenefits = _ref7.productBenefits;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, productCardDebitLinkName ? {
        cardDebit: productCardDebitLinkUrl && productCardDebitLinkUrl.includes(process.env.APP_MINFIN_DOMAIN) ? /*#__PURE__*/_jsx("a", {
          target: LINK.blank,
          href: productCardDebitLinkUrl,
          rel: LINK.relIsolated
        }, void 0, productCardDebitLinkName) : /*#__PURE__*/_jsx("span", {}, void 0, productCardDebitLinkName)
      } : {}), productCardCreditLinkName ? {
        cardCredit: productCardCreditLinkUrl && productCardCreditLinkUrl.includes(process.env.APP_MINFIN_DOMAIN) ? /*#__PURE__*/_jsx("a", {
          target: LINK.blank,
          href: productCardCreditLinkUrl,
          rel: LINK.relIsolated
        }, void 0, productCardCreditLinkName) : /*#__PURE__*/_jsx("span", {}, void 0, productCardCreditLinkName)
      } : {}), {}, {
        internetBanking: [clientBankWebLink && clientBankWebLink.includes(process.env.APP_MINFIN_DOMAIN) ? /*#__PURE__*/_jsx("a", {
          target: LINK.blank,
          href: clientBankWebLink,
          rel: LINK.relIsolated
        }, void 0, productClientBankName || formatMessage({
          id: 'MenuItems.params.site'
        })) : /*#__PURE__*/_jsx("span", {}, void 0, productClientBankName || formatMessage({
          id: 'MenuItems.params.site'
        })), clientBankAppIosLink && clientBankAppIosLink.includes(process.env.APP_MINFIN_DOMAIN) ? /*#__PURE__*/_jsx("a", {
          target: LINK.blank,
          href: clientBankAppIosLink,
          rel: LINK.relIsolated
        }, void 0, formatMessage({
          id: 'MenuItems.params.appStore'
        })) : /*#__PURE__*/_jsx("span", {}, void 0, formatMessage({
          id: 'MenuItems.params.appStore'
        })), clientBankAppAndroidLink && clientBankAppAndroidLink.includes(process.env.APP_MINFIN_DOMAIN) ? /*#__PURE__*/_jsx("a", {
          target: LINK.blank,
          href: clientBankAppAndroidLink,
          rel: LINK.relIsolated
        }, void 0, formatMessage({
          id: 'MenuItems.params.googlePlay'
        })) : /*#__PURE__*/_jsx("span", {}, void 0, formatMessage({
          id: 'MenuItems.params.googlePlay'
        }))].filter(function (el) {
          return !!el;
        }),
        conciergeService: productConciergeServiceDescription || (productConciergeService ? formatMessage({
          id: 'MenuItems.params.available'
        }) : formatMessage({
          id: 'MenuItems.params.none'
        }))
      }, productAccountStatementDescription ? {
        accountStatement: productAccountStatementDescription
      } : {}), {}, {
        businessCredits: productBusinessCreditsDescription || formatMessage({
          id: 'MenuItems.params.none'
        }),
        businessDeposits: productBusinessDepositsDescription || formatMessage({
          id: 'MenuItems.params.none'
        }),
        cashCollection: productCashCollectionDescription || formatMessage({
          id: 'MenuItems.params.none'
        })
      }, productBenefits ? {
        benefits: productBenefits
      } : {});
    }
  }];
  return menu;
};
export var getMoreInfo = function getMoreInfo(formatMessage) {
  var moreInfo = [{
    name: MORE_INFO_NAMES.payments,
    getValue: function getValue(_ref8) {
      var paymentPercent = _ref8.paymentPercent,
          paymentAbsolute = _ref8.paymentAbsolute,
          paymentMin = _ref8.paymentMin;
      return getFormattedPayments(formatMessage, paymentPercent, paymentAbsolute, paymentMin);
    },
    hint: function hint(_ref9) {
      var paymentDescription = _ref9.paymentDescription;
      return !!paymentDescription && paymentDescription;
    }
  }, {
    name: MORE_INFO_NAMES.service,
    getValue: function getValue(_ref10) {
      var monthlyFee = _ref10.monthlyFee;
      var fee = monthlyFee ? "".concat(monthlyFee, " ").concat(formatMessage({
        id: 'MenuItems.params.UAH'
      })) : formatMessage({
        id: 'MenuItems.params.free'
      });
      return fee;
    },
    hint: function hint(_ref11) {
      var monthlyFeeDescription = _ref11.monthlyFeeDescription;
      return !!monthlyFeeDescription && monthlyFeeDescription;
    }
  }, {
    name: MORE_INFO_NAMES.cashWithdrawal,
    getValue: function getValue(_ref12) {
      var withdrawalAtmPercent = _ref12.withdrawalAtmPercent,
          withdrawalAtmAbsolute = _ref12.withdrawalAtmAbsolute,
          withdrawalAtmMin = _ref12.withdrawalAtmMin;
      return getFormattedPayments(formatMessage, withdrawalAtmPercent, withdrawalAtmAbsolute, withdrawalAtmMin);
    },
    hint: function hint(_ref13) {
      var withdrawalAtmDescription = _ref13.withdrawalAtmDescription;
      return !!withdrawalAtmDescription && withdrawalAtmDescription;
    }
  }, {
    name: MORE_INFO_NAMES.cashDeposit,
    getValue: function getValue(_ref14) {
      var proceedsEnrollmentCashboxPercent = _ref14.proceedsEnrollmentCashboxPercent,
          proceedsEnrollmentCashboxAbsolute = _ref14.proceedsEnrollmentCashboxAbsolute,
          proceedsEnrollmentCashboxMin = _ref14.proceedsEnrollmentCashboxMin;
      return getFormattedPayments(formatMessage, proceedsEnrollmentCashboxPercent, proceedsEnrollmentCashboxAbsolute, proceedsEnrollmentCashboxMin);
    },
    hint: function hint(_ref15) {
      var proceedsEnrollmentCashboxDescription = _ref15.proceedsEnrollmentCashboxDescription;
      return !!proceedsEnrollmentCashboxDescription && proceedsEnrollmentCashboxDescription;
    }
  }];
  return moreInfo;
};
export var getBenefits = function getBenefits(formatMessage, card) {
  var benefits = [card.clientBankName && formatMessage({
    id: 'BankCardItem.moreInfoBlock.benefits.clientBank'
  }), card.productAccountOpeningRemote && formatMessage({
    id: 'BankCardItem.moreInfoBlock.benefits.accountOpeningRemote'
  }), card.productConciergeService && formatMessage({
    id: 'BankCardItem.moreInfoBlock.benefits.conciergeService'
  }), card.tradeAcquiringAvailable && formatMessage({
    id: 'BankCardItem.moreInfoBlock.benefits.tradeAcquiring'
  }), card.internetAcquiringAvailable && formatMessage({
    id: 'BankCardItem.moreInfoBlock.benefits.internetAcquiring'
  })].filter(function (el) {
    return !!el;
  }).slice(0, 2);
  return benefits;
};